<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} {{aLang.ads_title}}</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} {{aLang.ads_title}}</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} {{aLang.ads_title}}</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="8" sm="12">
              <el-form-item :label="aLang.ads_banner_name" prop="ten_banner">
                <el-input
                  type="text"
                  v-model="mData.dataForm.ten_banner"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  @change="() => {mData.dataForm.ten_banner = mData.dataForm.ten_banner.trim()}"
                />
              </el-form-item>
            </b-col>
            <b-col md="2" sm="6">
              <el-form-item :label="aLang.ads_screen" prop="vi_tri">
                <el-select
                  v-model="mData.dataForm.vi_tri"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listManHinh"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="2" sm="6">
              <el-form-item :label="aLang.nc_order" prop="thu_tu">
                <el-input
                  type="number"
                  v-model="mData.dataForm.thu_tu"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  min="0"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="8" sm="10">
              <el-form-item :label="aLang.ads_link" prop="link_quang_cao">
                <el-input
                  type="text"
                  v-model="mData.dataForm.link_quang_cao"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="2" sm="6">
              <el-form-item :label="aLang.nc_language" prop="ngon_ngu">
                <el-select
                  v-model="mData.dataForm.ngon_ngu"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listNgonNgu"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="2" sm="2">
              <el-form-item label=" " prop="hien_thi">
                <el-checkbox
                  v-model="mData.dataForm.hien_thi"
                  :disabled="mData.viewMode == 'detail'"
                >{{aLang.ads_visible}}</el-checkbox>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <el-form-item class="mb-0" :label="aLang.ads_visibleImage">
                <el-upload
                  action
                  :auto-upload="false"
                  list-type="picture-card"
                  :limit="mData.fileUploadOption.AnhDaiDien.limit"
                  :accept="mData.fileUploadOption.AnhDaiDien.accept"
                  :on-change="fn_uploadChangeAnhDaiDien"
                  :on-preview="fn_uploadPreviewAnhDaiDien"
                  :on-remove="fn_uploadRemoveAnhDaiDien"
                  :on-exceed="fn_uploadExceedAnhDaiDien"
                  :file-list="mData.fileUploadOption.AnhDaiDien.fileList"
                  :disabled="mData.viewMode == 'detail'"
                  :class="[mData.fileUploadOption.AnhDaiDien.fileList.length > 0 ? 'hidden-icon-upload' : '']"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog
                  :close-on-click-modal="true"
                  :visible.sync="mData.fileUploadOption.AnhDaiDien.dialogVisible"
                  width="60%"
                  top="51px"
                  title="Chi tiết"
                >
                  <img width="100%" :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import QuangCaoApi from '@/moduleApi/QuangCaoApi';
import QuangCaoModel from '@/views/admin/QuangCao/QuangCaoModel';

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "QuangCao",
        dataDefault: {
          roles: DataService.rolesInForm,
          listManHinh: MethodService.copyObject(QuangCaoModel.listManHinh),
          listNgonNgu: DataService.Languages
        },
        fileUploadOption: {
          AnhDaiDien: MethodService.copyObject(
            QuangCaoModel.dataFormOther.fileUploadOption.AnhDaiDien
          )
        },
        dataForm: MethodService.copyObject(QuangCaoModel.dataForm),
        validForm: QuangCaoModel.validForm,
        dialog: {}
      }
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          if (type == "create") {
            await QuangCaoApi.create(this.mData.dataForm);
            this.fn_resetForm();
            this.fn_go();
          }
          if (type == "update") {
            this.mData.dataForm.id = this.$router.currentRoute.params.id;
            await QuangCaoApi.update(this.mData.dataForm);
            this.fn_go();
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await QuangCaoApi.findById(id);

      if (res.result && res.result.anh_hien_thi) {
        let data = {
          id: res.result.anh_hien_thi,
          name: res.result.anh_hien_thi,
          url: ExtensionService.urlImg + res.result.anh_hien_thi
        };
        this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
      }

      this.mData.dataForm = res.result;
      console.log("this.mData.dataForm",this.mData.dataForm);
    },
    async fn_initDataDefault() {},

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },
    fn_uploadRemoveAnhDaiDien(file, fileList) {
      this.mData.dataForm.anh_hien_thi = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "quangCao")
        .then(res => {
          this.mData.dataForm.anh_hien_thi = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
        })
        .catch(error => {
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien(files, fileList) {
      window.toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {

      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },
  },
  created: function() {
    this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function() {}
};
</script>
